import styles from './LightHouse.module.css';
import React, { useState, useRef, useMemo, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import HeaderMain from './component/HeaderMain';
import { Link, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import $ from "jquery";
import FortuneList from './routes/FortuneList';
import FortuneInfo from './routes/FortuneInfo';
import Constellation from './component/Constellation';
import Loading from './component/Loading';
import NotFound from './routes/NotFound';
import UnseResult from './routes/UnseResult';
import { UnseProvider } from './context/UnseContext';
import { PointProvider, usePoint } from './context/PointContext';
import AgreePrivacy from './routes/AgreePrivacy';
import AuthCallback from './routes/AuthCallback';
import PointHistory from './routes/PointHistory';
import FortuneHistory from './routes/FortuneHistory';
import InsufficientPointPopup from './component/InsufficientPointPopup';
import { Pagination } from 'swiper/modules';
import { setHead } from '../utils/head';
import styled, { keyframes } from 'styled-components';
import { Helmet } from 'react-helmet-async';
import AgreePrivacyPopUp from './component/AgreePrivacyPopUp';

// 로그인/회원가입 메시지 팝업 컴포넌트
function AuthMessagePopup() {
    const [showMessage, setShowMessage] = useState(false);
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        const authMessage = localStorage.getItem('lighthouse_authMessage');
        if (authMessage) {
            setMessageType(authMessage);
            setShowMessage(true);
            localStorage.removeItem('lighthouse_authMessage');
            setTimeout(() => setShowMessage(false), 2500);
        }
    }, []);

    if (!showMessage) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0,0,0,0.95)',
            padding: '40px 60px',
            borderRadius: '20px',
            textAlign: 'center',
            zIndex: 10002,
            border: '2px solid rgba(81, 207, 102, 0.3)'
        }}>
            <div style={{ fontSize: '60px', marginBottom: '15px' }}>
                {messageType === 'signup' ? '🎉' : '👋'}
            </div>
            <div style={{ fontSize: '18px', color: '#fff', fontWeight: 'bold' , wordBreak: 'keep-all'}}>
                {messageType === 'signup' ? '회원가입 되었습니다!' : '로그인 되었습니다!'}
            </div>
            {messageType === 'signup' && (
                <div style={{ fontSize: '14px', color: '#51cf66', marginTop: '10px' }}>
                    환영합니다!
                </div>
            )}
        </div>
    );
}

// 자동 출석체크 컴포넌트
function AutoAttendanceChecker() {
    const { autoCheckAttendance, fetchPoint } = usePoint();
    const memberId = localStorage.getItem("lighthouse_memberId");
    const socialLoggedIn = localStorage.getItem("lighthouse_socialLoggedIn");
    const [showReward, setShowReward] = useState(false);
    const [earnedPoint, setEarnedPoint] = useState(0);

    useEffect(() => {
        if (socialLoggedIn === 'true' && memberId && memberId !== 'null') {
            // 먼저 포인트 조회
            fetchPoint(memberId);
            // 그 다음 자동 출석체크 (로그인 메시지 팝업 후에 표시되도록 딜레이)
            setTimeout(() => {
                autoCheckAttendance(memberId, (earned) => {
                    setEarnedPoint(earned);
                    setShowReward(true);
                    setTimeout(() => setShowReward(false), 3000);
                });
            }, 2800);
        }
    }, []);

    if (!showReward) return null;

    return (
        <div className='attendanceBox' style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0,0,0,0.95)',
            padding: '40px',
            borderRadius: '20px',
            textAlign: 'center',
            zIndex: 10001,
            border: '2px solid rgba(255,215,0,0.3)',
        }}>
            <div style={{ fontSize: '60px', marginBottom: '15px' }}>&#127881;</div>
            <div style={{ fontSize: '16px', color: '#fff', marginBottom: '8px', fontWeight: 'bold', wordBreak:'keep-all' }}>
                출석체크 완료!
            </div>
            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#FFD700' }}>
                +{earnedPoint}P
            </div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '10px', wordBreak:'keep-all', lineHeight:'1.3'}}>
                매일 방문하면 포인트가 쌓여요!
            </div>
        </div>
    );
}


const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const beamRotate = keyframes`
    0% { transform: rotate(-12deg); }
    100% { transform: rotate(12deg); }
`

const Cloud = styled.img`
    width: 100%;
    max-width: 578px;
    position: absolute;
    left: 0;
    bottom: 74px;
    animation: ${cloudFloat} 30s linear infinite;

    @media(max-width : 1024px){
            max-width : 100.0000vw;
            bottom: 12.8906vw
        }

    @media(max-width : 520px){
        max-width: 111.1538vw;
        bottom: 13.2308vw;
    }
`;

const Beam = styled.img`
    width: 100%;
    max-width: 489px;
    position: absolute;
    right: 52px;
    top: 4px;
    transform-origin: right center;
    z-index: -1;
    animation: ${beamRotate} 6s ease-in-out infinite alternate;

    @media(max-width : 1024px){
        max-width : 100.0000vw;
        right: 9.2773vw;
        top: 0.3906vw;
    }

    @media(max-width : 520px){
        max-width: 94.0385vw;
        right: 10.0000vw;
        top: 0.7692vw;
    }
`

// 메인 컨텐츠 컴포넌트 (포인트 사용을 위해 분리)
function MainContent({ cards, memberInfo, menuList, memberId, navigate, apiPoint }) {
    const { point: contextPoint, showPointInsufficient } = usePoint();
    // localStorage 기반 로그인 체크 (SideNav와 동일)
    const socialLoggedIn = localStorage.getItem("lighthouse_socialLoggedIn");
    const isLoggedIn = socialLoggedIn === 'true';
    const hasInfo = memberId && memberId !== 'null' && memberId !== 'undefined';
    // 포인트는 API에서 받은 값 우선 사용
    const point = apiPoint || contextPoint;

    const NAVER_CLIENT_ID = 'wjbMqVYTiRku00euvWoQ';
    const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO_CLIENT_ID || '871d99da7ecf53d6b5ddb3b06b1cf743';
    const KAKAO_JS_KEY = process.env.REACT_APP_KAKAO_JS_KEY || 'a9638f6b6ef48bd58fab13cb3c61fa62';

    // Kakao SDK 초기화
    useEffect(() => {
        if (window.Kakao && !window.Kakao.isInitialized()) {
            window.Kakao.init(KAKAO_JS_KEY);
            console.log('Kakao SDK initialized:', window.Kakao.isInitialized());
        }
    }, []);

    const handleNaverLogin = () => {
        const baseUrl = window.location.origin;
        const redirectUri = encodeURIComponent(`${baseUrl}/lighthouse/auth/callback/naver`);
        const state = Math.random().toString(36).substring(7);
        localStorage.setItem('naver_state', state);
        const naverAuthUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`;
        window.location.href = naverAuthUrl;
    };

    const handleKakaoLogin = () => {
        const redirectUri = encodeURIComponent(`${window.location.origin}/lighthouse/auth/callback/kakao`);
        const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_CLIENT_ID}&redirect_uri=${redirectUri}`;
        window.location.href = kakaoAuthUrl;
    };

    const handleFortuneClick = (card) => {
        // 1. 로그인 체크
        if (!isLoggedIn) {
            alert('운세를 보려면 로그인이 필요합니다.\n메뉴에서 네이버 또는 카카오로 로그인해주세요.');
            return;
        }

        // 2. 포인트 체크 (가격이 있는 경우)
        const price = card.POINT_PRICE || 0;
        if (price > 0 && point < price) {
            showPointInsufficient(price, point);
            return;
        }

        // 3. 정보 입력 페이지로 이동
        navigate(`FortuneInfo/${card.ORDER_ID}`);
    };

    return (
        <div className='meadBox meadBox_lightHouse'>
            <div className='main_top_banner'>
                <h4 className='bannerTitle'>
                    <img src={process.env.PUBLIC_URL + '/image/lightHouse_logo.png'} alt='소원등대' />
                </h4>

                <div className='lightHouseInfo'>
                    <div className='lightHouse_title_banner'>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/lightHouse_banner_title.png'} alt='' />
                        <h5 className='title'>
                            {isLoggedIn ? memberInfo.TITLE : '로그인하고 운세를 확인하세요!'}
                        </h5>
                    </div>
                    {/* 로그인 시에만 정보 입력 버튼 표시 */}
                    {isLoggedIn && (
                        <Link to="FortuneInfo" className='userScore'>
                            <img src={process.env.PUBLIC_URL + `/lightHouseImg/today_score${memberInfo.TODAY_SCORE}.png`} alt="" />
                            <img src={process.env.PUBLIC_URL + '/lightHouseImg/lighthouse_keeper.png'} alt="등대지기" className='keeperImg' />
                        </Link>
                    )}
                    {/* 로그인 안됨 → 네이버/카카오 로그인 버튼 */}
                    {!isLoggedIn && (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            margin: '15px 0',
                            padding: '0 20px'
                        }}>
                            <button
                                onClick={handleNaverLogin}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    background: '#03C75A',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer'
                                }}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.273 12.845L7.376 0H0v24h7.727V11.155L16.624 24H24V0h-7.727v12.845z" fill="white"/>
                                </svg>
                                네이버 로그인
                            </button>
                            <button
                                onClick={handleKakaoLogin}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#000000',
                                    background: '#FEE500',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer'
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10 3C5.58172 3 2 5.76903 2 9.16667C2 11.3369 3.48276 13.2355 5.7379 14.3308L4.92683 17.5122C4.86556 17.7529 5.14111 17.9434 5.35006 17.8041L9.21316 15.2321C9.46947 15.2761 9.73218 15.3 10 15.3C14.4183 15.3 18 12.564 18 9.16667C18 5.76903 14.4183 3 10 3Z" fill="#000000"/>
                                </svg>
                                카카오 로그인
                            </button>
                        </div>
                    )}
                    {/* 로그인됨 → 운세 정보 표시 */}
                    {isLoggedIn && (
                        <div className='lightHouseInfo_content'>
                            <FortuneResult memberInfo={memberInfo}></FortuneResult>
                        </div>
                    )}
                </div>

                {/* 로그인 시 포인트 표시 */}
                {isLoggedIn && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        margin: '15px 0',
                        padding: '12px 20px',
                        background: 'rgba(255,215,0,0.1)',
                        borderRadius: '12px',
                        border: '1px solid rgba(255,215,0,0.2)'
                    }}>
                        <span style={{ fontSize: '14px', color: '#aaa' }}>내 포인트</span>
                        <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#FFD700' }}>
                            {point.toLocaleString()}P
                        </span>
                    </div>
                )}

                <div className="lightHouseCollect">
                    <h4 className="collectTitle">
                        <img src={process.env.PUBLIC_URL + `/lightHouseImg/collect_icon.png`} alt="" />
                        운세 모아보기
                    </h4>
                    <ul className="lightHouseList">
                        {
                            cards.map((card, i) => {
                                const price = card.POINT_PRICE || 0;
                                return (
                                    <li key={i} onClick={() => handleFortuneClick(card)}>
                                        <div className='lightHouseList_inner'>
                                            <p className='unseIcon'>
                                                <img src={process.env.PUBLIC_URL + `/lightHouseImg/daetong_card_icon${card.ORDER_ID}.png`} alt='' />
                                            </p>
                                            <div className='LgUnseList_contetn'>
                                                <h5>{card.TITLE}</h5>
                                                <p>{card.CONTENT}</p>
                                                {/* 가격 표시 */}
                                                {price > 0 && (
                                                    <span style={{
                                                        display: 'inline-block',
                                                        marginTop: '8px',
                                                        padding: '4px 12px',
                                                        background: '#1a237e',
                                                        borderRadius: '12px',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        color: '#FFD700'
                                                    }}>
                                                        {price}P
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>

            </div>
        </div>
    );
}

function LightHouseApp() {
    const [fortuneList, setFortuneList] = useState(false);
    const [agreePrivacyTab, setAgreePrivacyTab] = useState(false);
    const [data, setData] = useState(null);
    const [unseResult, setUnseResult] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const memberId = localStorage.getItem("lighthouse_memberId");
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;
    const navigate = useNavigate();

    useEffect(() => {
        $.ajax({
            url: `${API_BASE_URL}/getLighthouseMain`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ "member_id": memberId }),
            cache: false,
            headers: {
                APIKEY: APIKEY,
            },
            success: function (res) {
                if (res.code !== "0") {
                    console.error("API Error:", res.msg);
                    return false;
                }
                setData(res);
            },
            error: function (xhr, status, err) {
                console.error("에러:", err);
            },
        });

        localStorage.setItem("lighthouse_memberId", memberId);

        setHead("소원등대", "/image/favicon3.png");

    }, []);



    // function getUnseResult(unseId, memberId) {
    //   $.ajax({
    //     url: `${API_BASE_URL}/getUnse`, 
    //     type: "POST",
    //     contentType: "application/json",
    //     dataType: "json",
    //     data: JSON.stringify({"member_id":memberId, "unse_id":unseId}),
    //     cache: false,
    //     headers: {
    //       APIKEY: APIKEY,
    //     },
    //     success: function (res) {
    //       if(res.code != "0") {
    //         alert(res.msg); return false;
    //       }
    //       console.log("응답:", res);
    //       setUnseResult(res);
    //       // console.log(unseResult.unseResult);
    //     },
    //     error: function (xhr, status, err) {
    //       console.error("에러:", err);
    //       console.log("상태:", xhr.status, "응답:", xhr.responseText);
    //     },
    //   }); return;
    // }



    if (!data) {
        return;
    }

    const cards = data.unseList;
    const memberInfo = data.memberInfo;
    const menuList = data.menuList;

    if (agreePrivacyTab) {
        document.body.style.overflow = "hidden"; // 팝업 열림: 스크롤 막기
    } else {
        document.body.style.overflow = "";       // 팝업 닫힘: 원복
    }


    return (
        <PointProvider>
            <UnseProvider>
                <div className={`App ${styles.AppLightHouse}`}>
                    <AuthMessagePopup />
                    <AutoAttendanceChecker />
                    <InsufficientPointPopup />
                {/* <>
                    <Helmet>
                        <meta name="description" content="소원등대에서는 무료로 오늘의 운세와 궁합 정보를 제공합니다. 쉽고 빠르게 운세를 확인하세요." />
                        <meta name="keywords" content="운세, 오늘의 운세, 궁합, 무료 운세, 별자리 운세" />

                        <meta property="og:type" content="website" />
                        <meta property="og:title" content="소원등대 - 무료 오늘의 운세와 궁합 서비스" />
                        <meta property="og:description" content="소원등대에서 무료로 오늘의 운세와 궁합 정보를 확인하세요. 쉽고 빠른 운세 서비스로 운빨을 체크하세요." />

                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content="소원등대 - 무료 오늘의 운세와 궁합 정보" />
                        <meta name="twitter:description" content="소원등대에서 무료로 오늘의 운세와 궁합을 확인하세요. 빠르고 간편한 운세 서비스로 운을 점쳐보세요." />
                    </Helmet>
                </> */}
                <div className='inner'>
                    <Routes>
                        <Route index element={
                            <>
                                <div className={`mainContent ${styles.mainContent}`}>
                                    <div className={`mainInner ${styles.mainInner_lightHouse}`}>
                                        <HeaderMain variant="mainHeader" menuList={menuList} />
                                        <MainContent
                                            cards={cards}
                                            memberInfo={memberInfo}
                                            menuList={menuList}
                                            memberId={memberId}
                                            navigate={navigate}
                                            apiPoint={data.point || 0}
                                        />
                                    </div>
                                </div>
                            </>
                        } />
                        <Route path="FortuneInfo/:orderId" element={
                            <div className={`FortuneInfoPage ${styles.FortuneInfoPage_lightHouse}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <FortuneInfo cards={cards} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab} Loading={Loading} Constellation={Constellation}/>
                                <div className={`agreePrivacyPage agreePopUp ${agreePrivacyTab ? 'active' : ''} ${styles.agreePrivacyPage_lightHouse}`}>
                                    <AgreePrivacyPopUp  setAgreePrivacyTab={setAgreePrivacyTab}/>
                                </div>
                            </div>
                        } />
                        <Route path="FortuneInfo" element={
                            <div className={`FortuneInfoPage ${styles.FortuneInfoPage_lightHouse}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <FortuneInfo cards={cards} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab} Loading={Loading} Constellation={Constellation}/>
                                <div className={`agreePrivacyPage agreePopUp ${agreePrivacyTab ? 'active' : ''} ${styles.agreePrivacyPage_lightHouse}`}>
                                    <AgreePrivacyPopUp setAgreePrivacyTab={setAgreePrivacyTab}/>
                                </div>
                            </div>
                        } />
                        <Route path='UnseResult' element={
                            <div className={`UnseResultPage ${styles.UnseResultPage_lightHouse}`}>
                                <HeaderMain variant="backHeaderOnly" menuList={menuList} />
                                {/* <Constellation></Constellation> */}
                                <UnseResult unseResult={unseResult} />
                            </div>
                        } />
                        <Route path='FortuneList' element={
                            <div className={`fortuneListPage ${styles.fortuneListPage_lightHouse}`}>
                                <HeaderMain variant="backHeader" menuList={menuList} />
                                <FortuneList cards={cards} fortuneList={fortuneList} />
                                {/* <Constellation></Constellation> */}
                            </div>
                        } />
                        <Route path='AgreePrivacy' element={
                            <div className={`agreePrivacyPage ${styles.agreePrivacyPage_lightHouse}`}>
                                <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} />
                                <AgreePrivacy></AgreePrivacy>
                            </div>
                        } />
                        <Route path='auth/callback/:provider' element={<AuthCallback />} />
                        <Route path='point-history' element={
                            <div className={`pointHistoryPage ${styles.pointHistoryPage_lightHouse}`}>
                                <HeaderMain variant="backHeaderOnly" menuList={menuList} />
                                <PointHistory />
                            </div>
                        } />
                        <Route path='fortune-history' element={
                            <div className={`fortuneHistoryPage ${styles.pointHistoryPage_lightHouse}`}>
                                <HeaderMain variant="backHeaderOnly" menuList={menuList} />
                                <FortuneHistory />
                            </div>
                        } />
                        <Route path='*' element={<NotFound />} />
                    </Routes>


                    <div className='lightHouseIllust'>
                        <div className='lightHouseIllust_inner'>
                            <Cloud src={process.env.PUBLIC_URL + '/lightHouseImg/cloud.png'} alt='cloud' />
                            <img src={process.env.PUBLIC_URL + '/lightHouseImg/lightHouse.png'} alt='Light House' className='lightHouse' />
                            <Beam src={process.env.PUBLIC_URL + '/lightHouseImg/beam.png'} alt='beam' />
                        </div>
                    </div>
                </div>

                </div>
            </UnseProvider>
        </PointProvider>
    );
}

function FortuneResult({ memberInfo }) {
    return (
        <div dangerouslySetInnerHTML={{ __html: memberInfo.CONTENT }} />
    );
}


export default LightHouseApp;
